import { useState } from "react";
import Axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from 'react-loader-spinner'
import Logo from "../assets/footer-logo.png";
import Instagram from "../assets/instagram.svg";
import Tiktok from "../assets/tiktok.svg";
import LinkedIn from "../assets/linkedin.svg";
import Envelope from "../assets/envelope.svg";

const Footer = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubscribe = async () => {
        if (!email) {
            toast.error("Please enter an email address.");
            return;
        }
        setLoading(true);
        try {
            const res = await Axios.post("https://api.getquickcare.com/productAdvisory/subscribe", { email });
            toast.success(res.data.message);
            setEmail("");
        } catch (error) {
            toast.error("Subscription failed. Try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <footer className="footer">
                <div className="footer-left">
                    <div className="logo">
                        <img src={Logo} alt="logo" />
                    </div>
                    <div className="newsletter">
                        <p className="latest-news">Latest News</p>
                        <div className="subscribe">
                            <div className="input-container">
                                <img src={Envelope} alt="envelope" className="email-icon" />
                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <button disabled={loading} onClick={handleSubscribe} className="subscribe-button">
                                    {loading ? (
                                        <span className="loading-content">
                                            Subscribing <Oval height={18} width={18} color="white" ariaLabel="loading" />
                                        </span>
                                    ) : (
                                        'Subscribe'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-right">
                    <div className="footer-links-container">
                        <div className="footer-links">
                            <a href="/aboutus">About Us</a>
                            <a href="/contact">Contact</a>
                        </div>
                        <div className="footer-links">
                            <a href="/investors">Investors</a>
                            <a href="/community">Community</a>
                            <a href="/startups">Startups</a>
                            <a href="/advisors">Advisors</a>
                        </div>
                    </div>
                    <div className="social-icons">
                        <img src={Instagram} alt="Instagram" className="icon" />
                        <img src={Tiktok} alt="Tiktok" className="icon" />
                        <img src={LinkedIn} alt="LinkedIn" className="icon" />
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;